<template lang="pug">
v-container.pa-8(fluid)
  v-row.mb-2(no-gutters align="center")
    v-col.shrink
      v-btn.ml-n3(text icon @click="goBack" height)
        v-icon(color="neutral700" :size="24") mdi-arrow-left
    v-col.ml-3
      .text-2xl.font-semibold.neutral700--text Billings
  v-row.pb-2.pb-md-0(no-gutters)
    v-col(cols="8")
      v-tabs(v-model="tabs" color="basic700" :height="44" :grow="isMobileScreen" active-class="font-semibold" @change="tabChanged")
        v-tab.text-sm.font-medium.text-none.px-4 {{ $t('all') }}
        v-tab.text-sm.font-medium.text-none.px-4 Paid
        v-tab.text-sm.font-medium.text-none.px-4 Outstanding panel
        v-tab.text-sm.font-medium.text-none.px-4 Outstanding self-pay
        v-tab.text-sm.font-medium.text-none.px-4 e-Invoice Invalid
        v-tab.text-sm.font-medium.text-none.px-4 e-Invoice Unsubmitted
    v-col(cols="4")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat :placeholder="$t('type_to_search')" hide-details clearable autofocus)
        div
          customize-column-menu(type="billing" :showTooltip="false" iconSize="21")

  v-expand-transition
    .d-flex.align-center.mt-4(v-if="checkedBills.length")
      //- v-btn.button-Aa-small.mr-3.px-3(@click="onDelete" color="danger500" height=32 outlined depressed) {{ $t('delete') }}
      v-btn.button-Aa-small.mr-3.px-3(@click="bulkDownloadReceipt" color="primary" outlined height=32 depressed) Download receipt
      v-btn.button-Aa-small.mr-3.px-3(@click="bulkDownloadInvoice" color="primary" outlined height=32 depressed) Download invoice
      v-btn.button-Aa-small.mr-3.px-3(@click="bulkClaimStatus" color="primary" outlined height=32 depressed) Update claim status
      a.link-s(@click="clearSelection") {{ $t('clear_selection') }}

  filter-row.my-2(ref="filter" :filters.sync="filters" :prop-filters="saveFilters")
  .data-table
    v-data-table.table-custom.mt-sm-4.pb-6(:headers="headers" :items="bills" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="selectBill")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      //- checked
      template(v-slot:item.checked="{ item }")
        div
          yc-checkbox(v-model="item.checked" @change="onChecked")
      //- amount
      template(v-slot:item.amount="{ item }")
        div.font-medium.neutral700--text {{ item.total_amount | displayPrice($currency) }}
      //- name
      template(v-slot:item.name="{ item }")
        div.neutral700--text {{ item.customer.name }}
      //- status
      template(v-slot:item.status="{ item }")
        template(v-if="item.total_amount > 0" )
          y-chip(v-if="item.paid" label="Paid" color="green")
            template(#prepend)
              v-icon.mr-1(size="12" color="success600") mdi-record
          y-chip(v-else label="Outstanding" color="red")
            template(#prepend)
              v-icon.mr-1(size="12" color="danger600") mdi-record
      //- invoice no
      template(v-slot:item.invoice_no="{ item }")
        div.neutral700--text Bill {{ '#' + item.rid }}
      //- payment methods
      template(v-slot:item.payment="{ item, index }")
        div(:id="`pm-${index}`" style="position: relative;")
        div.d-flex.align-center
          template(v-for="(txnarray, idx) in filteredArrays(item.transactions)")
            y-chip(:label="txnarray.payment_method" size="sm" chip-class="pa-1 mr-2" :key="`txn-${idx}-${txnarray.uid}`" outlined)
          v-tooltip(v-if="item.transactions.length !== filteredArrays(item.transactions).length" top :attach="`#pm-${index}`" color="neutral700")
            template(#activator="{ on, attrs }")
              div(v-bind="attrs" v-on="on")
                y-chip.cursor-help(v-bind="attrs" v-on="on" :label="`+${item.transactions.length - filteredArrays(item.transactions).length} more`" size="sm" chip-class="pa-1" outlined)
            div
              div(v-for="(pay, index) in item.transactions" :key="pay.id") {{ index + 1 }}. {{ pay.payment_method }}
      //- claim status
      template(v-slot:item.claim_status="{ item, index }")
        div(:id="`cs-${index}`" style="position: relative;")
        div.d-flex.align-center
          div(v-if="panels(item).length > 0")
            y-chip(:label="`${panels(item)[0].payment_method}: ${getClaimStatus(panels(item)[0].claim_status, 'text')}`" :color="getClaimStatus(panels(item)[0].claim_status, 'chip')" chip-class="pa-1 mr-2")
              template(#prepend)
                v-icon.mr-1(size="12" :color="getClaimStatus(panels(item)[0].claim_status, 'icon')") mdi-record
          v-tooltip(v-if="panels(item).length > 1" top :attach="`#cs-${index}`" color="neutral700")
            template(#activator="{ on, attrs }")
              div(v-bind="attrs" v-on="on")
                y-chip.cursor-help(v-bind="attrs" v-on="on" :label="`+${panels(item).length - 1} more`" size="sm" chip-class="pa-1" outlined)
            div
              template(v-for="(panel, idx) in panels(item)")
                div(:key="`panel-${idx + 1}`") {{ idx + 1 }}. {{ `${panel.payment_method}: ${getClaimStatus(panel.claim_status, 'text')}` }}

      //- record date
      template(v-slot:item.record_date="{ item }")
        div.neutral700--text {{ item.record_date | humanizeDate }}
      //- actions
      template(v-slot:item.actions="{ item, index }")
        div(@click.stop)
          v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
            template(#activator="{ on }")
              v-btn(icon small v-on="on")
                v-icon mdi-dots-horizontal
            v-list.py-0
              v-list-item(@click="downloadInvoiceReceipt('invoice', item)")
                v-list-item-title.text-sm.basic800--text Download invoice
              template(v-if="item.total_paid > 0 && item.transactions.map(m => m.channel).includes('self-pay')")
                v-divider
                v-list-item(@click="downloadInvoiceReceipt('receipt', item)")
                  v-list-item-title.text-sm.basic800--text Download receipt
              template(v-if="item.transactions.find(f => f.channel === 'panel')")
                v-divider
                v-list-item(@click="updateClaimStatus(item)")
                  v-list-item-title.text-sm.basic800--text Update claim status
              template(v-if="item.total_paid !== item.total_amount")
                v-divider
                v-list-item(@click="goToCheckout(item)")
                  v-list-item-title.text-sm.basic800--text Record payment
              v-divider
              v-list-item(@click="editInvoice(item)")
                v-list-item-title.text-sm.basic800--text Edit invoice

  div.d-flex.align-center(v-if="totalCount > pageSize")
    v-spacer
    yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

  .dialogs
    update-claim-dialog(v-if="openUpdateClaimDialog" :open.sync="openUpdateClaimDialog" :selected-bills="selectedBills" @reset="reset" @closed="closed")
    download-multiple-invoice-dialog(v-if="openSelectInvoiceDialog" :open.sync="openSelectInvoiceDialog" :documents="invoiceTemplates" :selectedBills="selectedBills" @closed="closed")
    download-multiple-receipt-dialog(v-if="openSelectReceiptDialog" :open.sync="openSelectReceiptDialog" :documents="invoiceTemplates" :selectedBills="selectedBills" @closed="closed")
        
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions, mapState } from 'vuex'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import FilterRow from '@/components/clinic/invoice/FilterRow.vue'
import UpdateClaimDialog from '@/components/clinic/dialogs/UpdateClaimDialog.vue'
import DownloadMultipleInvoiceDialog from '@/components/clinic/dialogs/DownloadMultipleInvoiceDialog.vue'
import DownloadMultipleReceiptDialog from '@/components/clinic/dialogs/DownloadMultipleReceiptDialog.vue'

export default {
  name: 'Billings',
  props: ['savePage', 'saveTab', 'saveSearch', 'saveFilters'],
  components: { CustomizeColumnMenu, FilterRow, UpdateClaimDialog, DownloadMultipleInvoiceDialog, DownloadMultipleReceiptDialog },
  data: () => ({
    isLoading: false,
    isFetching: false,
    showDetails: false,
    checkAll: false,
    showDeleteDialog: false,
    showSearchField: false,
    openUpdateClaimDialog: false,
    openSelectInvoiceDialog: false,
    openSelectReceiptDialog: false,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    tabs: 0,
    invoiceTemplates: [],
    bills: [],
    selectedBills: [],
    // selectedTransactions: [],
    checkedBills: [],
    filters: [],
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      company: 'getCompany',
      fields: 'clinic/getBillingFields'
    }),
    headers() {
      const filteredOptions = this.fields.filter(item => item.enable)
      const checkbox = {
        text: '',
        value: 'checked',
        sortable: false
      }
      const amount = {
        text: 'Amount',
        value: 'amount',
        class: 'text-table-header',
        width: '110',
      }
      const name = {
        text: 'Patient name',
        value: 'name',
        class: 'text-table-header'
      }
      filteredOptions.map(item => {
        item.text = item.field_name
        item.value = `${item.id}`.toLowerCase()
        item['class'] = 'text-table-header'
      })
      const actions = {
        text: '',
        value: 'actions',
        class: 'text-table-header'
      }
      return [checkbox, amount, name, ...filteredOptions, actions]
    },
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    filters () {
      this.fetchFirstPage()
    },
  },
  mounted () {
    this.checkRoute()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchInvoices () {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page: this.currentPage,
        company: this.company.id,
        form_type: 'registration',
        omit: 'products,payment_methods'
      }
      if (this.tabs === 1) { params.paid = true }
      if (this.tabs === 2) { params.paid = false; params.payment_channel = 'panel' }
      if (this.tabs === 3) { params.paid = false; params.payment_channel__ne = 'panel' }
      if (this.tabs === 4) { params.einvoice_status = 'Invalid' }
      if (this.tabs === 5) { params.has_einvoice = false }
      if (this.searchText) { params.search = this.searchText }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/invoices`, { params })
        .then(resp => {
          const data = resp.data
          this.bills = data.results
          this.bills.map(item => {
            item.checked = false
          })
          this.totalCount = resp.data.count
        })
        .catch(err => {
          let message = err.response?.data?.detail
          if (message.includes('Invalid page')) {
            this.fetchFirstPage()
          }
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    tabChanged () {
      this.searchText = null
      this.blurSearch()
      this.fetchFirstPage()
    },
    pageChanged() {
      this.fetchInvoices()
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchInvoices()
    },
    selectBill (data) {
      this.editInvoice(data)
      // data.checked = !data.checked
      // this.onChecked()
    },
    editInvoice (data) {
      // this.$router.push(`/admin/clinic/invoice/${data.pid}?origin=billings&tab=${this.tabs}`)
      let params = {
        pid: data.pid,
        origin: 'ClinicBillingsList',
        data: {
          params: {
            saveTab: this.tabs,
            savePage: this.currentPage,
            saveSearch: this.searchText,
            saveFilters: this.filters.length ? this.$refs.filter.dataFilters : null
          }
        }
      }
      this.$router.push({ name: 'ClinicInvoice', params })
    },
    goToCheckout (data) {
      // this.$router.push(`/admin/clinic/checkout/${data.pid}?origin=billings&tab=${this.tabs}`)
      let params = {
        pid: data.pid,
        origin: 'ClinicBillingsList',
        data: {
          params: {
            saveTab: this.tabs,
            savePage: this.currentPage,
            saveSearch: this.searchText,
            saveFilters: this.filters.length ? this.$refs.filter.dataFilters : null
          }
        }
      }
      this.$router.push({ name: 'ClinicCheckout', params })
    },
    onChecked() {
      this.checkedBills = this.bills.filter(item => item.checked === true)
      this.bills = [...this.bills]
      this.checkAll = false
    },
    onCheckedAll() {
      const clone = [...this.bills]
      clone.map(item => item.checked = this.checkAll)
      this.bills = [...clone]
      this.checkedBills = this.bills.filter(item => item.checked === true)
    },
    clearSelection() {
      this.checkAll = false
      this.onCheckedAll()
    },
    onDelete() {
      this.showDeleteDialog = true
    },
    updateClaimStatus (item) {
      this.updateSelectedTransactions([item])
      this.openUpdateClaimDialog = true
    },
    updateSelectedTransactions (bills) {
      bills.forEach(bill => {
        let tempTxn = bill.transactions.filter(f => f.channel === 'panel')
        if (tempTxn.length) {
          tempTxn.map(m => m.lead = bill.customer)
          this.selectedBills.push({
            rid: bill.rid,
            record_date: bill.record_date,
            lead: bill.customer,
            products: bill.products,
            transactions: tempTxn,
            pid: bill.pid
          })
        }
      })
    },
    downloadInvoiceReceipt (type, item) {
      this.selectedBills.push(item)
      this.checkDocumentTemplate(type)
    },
    async checkDocumentTemplate (type) {
      try {
        let params = {
          company: this.company.id,
          status: 'active',
          categories: type
        }
        const { data } = await this.$axios.get('/document_templates', { params })
        if (data.count > 1) {
          this.invoiceTemplates = data.results
          type === 'invoice' ? this.openSelectInvoiceDialog = true : this.openSelectReceiptDialog = true
          return
        }
        if (data.count === 1) {
          this.onDownload(type, data.results[0])
          return
        }
        this.showMessage(['error', this.$t('error_message.create_item_first', { item: this.$t('invoice').toLowerCase() })])
        this.$router.push('/admin/clinic/settings/document/templates')
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    },
    async onDownload (type, item) {
      await this.selectedBills.forEach(async selectedBill => {
        let key
        try {
          const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
          key = data.key
        } catch (error) {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          return
        }
        let baseUrl = process.env.VUE_APP_BASE_URL
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
          baseUrl = 'https://api-test.yezza.io'
        } else if (process.env.VUE_APP_ENV === 'prod') {
          baseUrl = 'https://export.yezza.io'
        }
        if (type === 'receipt') {
          let params = {
            company: this.company.id,
            pid: selectedBill.pid
          }
          await this.$axios.get('/transactions', { params })
            .then(async resp => {
              let transactions = resp.data.results
              await transactions.forEach(async transaction => {
                if (transaction.channel === 'self-pay') {
                  const url = `${baseUrl}/invoices/${selectedBill.pid}/preview_document?document_template=${item.id}&transaction=${transaction.uid}&key=${key}`
                  window.open(url,'_blank')
                }
              })
            })
            .catch(() => {})
        } else {
          const url = `${baseUrl}/invoices/${selectedBill.pid}/preview_document?document_template=${item.id}&key=${key}`
          window.open(url,'_blank')
        }
        
      })
      this.selectedBills = []
    },
    bulkDownloadReceipt () {
      this.selectedBills = this.checkedBills
      this.checkDocumentTemplate('receipt')
    },
    bulkDownloadInvoice () {
      this.selectedBills = this.checkedBills
      this.checkDocumentTemplate('invoice')
    },
    bulkClaimStatus () {
      this.updateSelectedTransactions(this.checkedBills)
      this.openUpdateClaimDialog = true
    },
    reset () {
      this.clearSelection()
      this.fetchFirstPage()
      this.closed()
    },
    closed () {
      this.selectedBills = []
      // this.selectedTransactions = []
      this.openUpdateClaimDialog = false
    },
    panels (item) {
      return item.transactions.filter(f => f.channel === 'panel') || []
    },
    getClaimStatus (claim, type) {
      if (type === 'text') {
        return `${claim.charAt(0).toUpperCase()}${claim.slice(1)}`
      } else if (type === 'chip') {
        switch(claim) {
          case 'new':
            return 'normal'
          case 'submitted':
            return 'orange'
          case 'approved':
            return 'blue'
          case 'received':
            return 'green'
          case 'rejected':
            return 'red'
          default:
            return 'normal'
        }
      } else if (type === 'icon') {
        switch(claim) {
          case 'new':
            return 'neutral500'
          case 'submitted':
            return 'warning500'
          case 'approved':
            return 'info500'
          case 'received':
            return 'success500'
          case 'rejected':
            return 'danger500'
          default:
            return 'neutral500'
        }
      } else {
        return claim
      }
    },
    checkRoute () {
      if (this.saveSearch) {
        this.searchText = this.saveSearch
        this.clickSearch()
      }
      if (this.savePage) {
        this.currentPage = this.savePage
      }
      if (this.saveTab) {
        this.tabs = this.saveTab
      }
      if (this.saveFilters) {
        this.$refs.filter.setFilters()
        return
      }
      this.fetchInvoices()      
    },
    filteredArrays (arrays) {
      if (arrays.length > 1) {
        let newArray = []
        let count = 0
        arrays.forEach((o, idx) => {
          count += o.payment_method.length
          if (idx === 0 || count <= 25) {
            newArray.push(o)
          }
        })
        return newArray
      }
      return arrays
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.bills.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.v-tooltip__content {
  top: unset !important;
  left: unset !important;
  /* margin-top: -45px !important; */
  position: absolute;
  bottom: 0;
}
::v-deep {
  .table-custom {
    .v-data-table__wrapper {
      overflow: visible !important;
    }
  } 
}
</style>